import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { DataGrid } from '@mui/x-data-grid';
import { IconButton, Box } from '@mui/material';
import { Edit } from '@mui/icons-material';
import { API_BASE_URL } from 'src/apiConfig';
import FinalGradeSolutionEditor from './finalGradeSolutionEditor';
import { useTranslation } from 'react-i18next';
import { useLocaleText } from 'src/helper/localeText';

/* ADMIN STRANA ZA UPRAVLJANJE FINALNIM REŠENJIMA */
function FinalGradeSolutionsManager() {
  const { t } = useTranslation();
  const [solutions, setSolutions] = useState([]);
  const [selectedSolution, setSelectedSolution] = useState(null);
  const localeText = useLocaleText();

  useEffect(() => {
    fetchSolutions();
  }, []);

  const fetchSolutions = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/api/finalGradeSolutions.php`
      );
      setSolutions(response.data);
    } catch (error) {
      console.error(t('solutions.errorFetchingSolutions'), error);
    }
  };

  const handleEdit = (solution) => {
    if (selectedSolution?.grade !== solution.grade) {
      setSelectedSolution(null); 
      setTimeout(() => {
        setSelectedSolution(solution); 
      }, 0);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: '10px'
      }}
    >
      <DataGrid
        rows={solutions}
        localeText={localeText}
        columns={[
          { field: 'grade', headerName: t('solutions.grade'), width: 80 },
          {
            field: 'solutions',
            headerName: t('solutions.solutions'),
            width: 400
          },
          { field: 'points', headerName: t('solutions.points'), width: 400 },
          {
            field: 'actions',
            headerName: t('solutions.actions'),
            renderCell: (params) => (
              <IconButton onClick={() => handleEdit(params.row)}>
                <Edit sx={{ color: '#1c75bc', fontSize: '24px' }} />
              </IconButton>
            ),
            width: 100
          }
        ]}
        rowsPerPageOptions={[5, 10, 15, 20]}
        pageSize={15}
        getRowId={(row) => row.grade}
        autoHeight
        sx={{
          width: '100%',
          maxWidth: '990px',
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
          borderRadius: '15px',
          border: 'none',
          backgroundColor: 'white',
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#2596be',
            color: '#fff',
            fontSize: '16px',
            fontWeight: 'bold',
            borderTopLeftRadius: '15px',
            borderTopRightRadius: '15px',
            padding: '16px'
          },
          '& .MuiDataGrid-footerContainer': {
            backgroundColor: '#f0f0f0',
            borderBottomLeftRadius: '15px',
            borderBottomRightRadius: '15px'
          },
          '& .MuiDataGrid-cell': {
            padding: '12px 16px',
            fontSize: '15px',
            color: '#333',
            '&:nth-of-type(even)': {
              backgroundColor: '#fafafa'
            }
          },
          '& .MuiIconButton-root': {
            color: '#2596be',
            '&:hover': {
              backgroundColor: '#e0f7fa',
              borderRadius: '50%'
            }
          }
        }}
      />

      {selectedSolution && (
        <Box sx={{ width: '30%', marginLeft: '0px', marginTop: '0px' }}>
          <FinalGradeSolutionEditor
            key={selectedSolution.grade}
            grade={selectedSolution ? selectedSolution.grade : ''}
            solutionString={selectedSolution ? selectedSolution.solutions : ''}
            pointsString={selectedSolution ? selectedSolution.points : ''}
            onSave={() => {
              fetchSolutions();
              setSelectedSolution(null);
            }}
            onCancel={() => setSelectedSolution(null)}
          />
        </Box>
      )}
    </Box>
  );
}

export default FinalGradeSolutionsManager;
